import * as React from "react";
import { useState } from "react";
import ButtonAppBar from "../Layout/AppBar";
import MobMenu from "../Layout/mobMenu";
import { TickerName, setJsonData } from "../../Redux/Action";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import axios from "axios";
import Rsl from "../Indicators/rsl";
import SMA from "../Indicators/sma";
import EMA from "../Indicators/ema";
import Returns from "../Indicators/returns";
import TechIndicator from "../Indicators/techindicators";
import { fetchIndicatorData } from "../Services/api";
import VolumeAnalysisTable from "../TableContainer/Table/IndividualTables.js/VolumeAnalysisTable";

const OutlinedCard = () => {
  const selectedExchange = useSelector((state) => state.SetExchange);
  const selecttimeFrame = useSelector((state) => state.ActiveButton);
  const selectIndicator = useSelector((state) => state.SelectedDropdownOption);

  const showApp = useSelector((state) => state.showAppBar);
  const dispatch = useDispatch();

  // const token =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InMiLCJuYmYiOjE3MTQzODg5NTIsImV4cCI6MTcxNDQ3NTM1MiwiaWF0IjoxNzE0Mzg4OTUyfQ.KgeibbxuX-bGdwTgk2xqC80vuiL4QZjsctR9-l6gTQg";
  // const tokenforIntraday =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IlNpdmEiLCJuYmYiOjE3MTU5Mjk1MDMsImV4cCI6MTcxNjAxNTkwMywiaWF0IjoxNzE1OTI5NTAzfQ.pgnstq2FSumDT3Z9Pu6wxwWXv75LV48KcNQEN3_mMzA";
  // useEffect(() => {
  //   const fetchIndicatorData = async () => {
  //     debugger;
  //     try {
  //       let timeframeToken;
  //       if (
  //         selecttimeFrame === "OneMinute" ||
  //         selecttimeFrame === "FiveMinute" ||
  //         selecttimeFrame === "FifteenMinute" ||
  //         selecttimeFrame === "ThirtyMinute" ||
  //         selecttimeFrame === "OneHour"
  //       ) {
  //         timeframeToken = tokenforIntraday;
  //       } else {
  //         timeframeToken = token;
  //       }
  //       const IndicatorApi = `https://idart.ftconline.in/api/eodanalytics/BulkData/Technicals/${selectedExchange}/${selectedExchange}CASH/${selecttimeFrame}`;
  //       const response = await axios.get(IndicatorApi, {
  //         headers: { Authorization: `Bearer ${timeframeToken}` },
  //       });
  //       dispatch(setJsonData(response.data));
  //       debugger;
  //     } catch (error) {
  //       console.error("Error fetching indicator data:", error);
  //     }
  //   };
  //   fetchIndicatorData();
  // }, [selecttimeFrame, selectedExchange, dispatch]);

  useEffect(() => {
    if (selectIndicator === "Indicator") {
      fetchIndicatorData(
        selecttimeFrame,
        selectedExchange,
        dispatch,
        setJsonData
      );
    }
  }, [selecttimeFrame, selectedExchange, selectIndicator, dispatch]);

  return (
    <div>
      {!showApp && (
        <div>
          <ButtonAppBar />
          <MobMenu></MobMenu>
        </div>
      )}
      {selectIndicator == "Indicator" && <TechIndicator />}
      {selectIndicator == "SMA" && <SMA />}
      {selectIndicator == "EMA" && <EMA />}
      {selectIndicator == "RS_LEVEL_FIBBO" && <Rsl />}
      {selectIndicator == "RS_LEVEL_CLASSIC" && <Rsl />}
      {selectIndicator == "Returns" && <Returns />}
      {selectIndicator == "Volume_Analysis" && <VolumeAnalysisTable />}
    </div>
  );
};

export default OutlinedCard;
